module.exports = __webpack_public_path__ + "static/media/game-score-active.5f5ad3e3.svg";